import * as React from 'react';
import {BlogPostsListPropType} from '@nls-2022/nls-bll';
import BlogPostsBasicDetails from './BlogPostBasicDetails';
const BlogPostsList = ({
  blogPosts,
  resultContext,
  blogPostsDispatch,
}: BlogPostsListPropType) => {
  if (blogPosts === undefined || blogPosts === null || blogPosts.length === 0) {
    return (
      <div data-testid="empty-blogposts-list" className="list-items">
        empty list
      </div>
    );
  }
  return (
    <section className="block">
      <h3>Blog Posts List</h3>
      <div className="flex flex-row">
        <div className="basis-1/6 pr-2 items-center justify-center h-14">
          Pub Date
        </div>
        <div className="hidden basis-1/5 items-center justify-center h-14">
          Published
        </div>
        <div className="basis-1/4 pr-2 items-center justify-center h-14">
          Title
        </div>
        <div className="basis-1/4 pr-2 items-center justify-center h-14">
          Excerpt
        </div>
        <div className="basis-2/6 pr-2 items-center justify-center h-14">
          Actions
        </div>
      </div>
      {blogPosts?.map(
        (blogPost: {
          ID: any;
          Title: string;
          Author: string;
          Slug: string;
          previousSlug: string;
          nextSlug: string;
          Excerpt: string;
          Content: string;
          PubDate: string;
          LastModified: string;
          IsPublished: boolean;
          IsStickyPost: boolean;
          Categories: string[];
          Comments: string[];
          AbsoluteUrl: string;
          Url: string;
        }) => {
          return (
            <BlogPostsBasicDetails
              key={blogPost.ID}
              blogPost={blogPost}
              blogPostsDispatch={blogPostsDispatch}
            />
          );
        },
      )}
    </section>
  );
};
export default BlogPostsList;
